<template>
  <div class="headBlock">
    <div class="pcHead">
      <div class="infoLt">
        <h1>Welcome to PrintDoors</h1>
        <h5>
          Your One-Stop Print-on-
          <span>Demand</span>
          <br>and Dropshipping Platform!
        </h5>
        <div class="infoWrap">
          <div class="infoItem">
            <span class="imgIcon">
              <img src="@/assets/homePage/top_1.png">
            </span>
            <span>No Minimum Order</span>
          </div>
          <div class="infoItem">
            <span class="imgIcon">
              <img src="@/assets/homePage/top_2.png">
            </span>
            <span>One-on-One Services</span>
          </div>
          <div class="infoItem">
            <span class="imgIcon">
              <img src="@/assets/homePage/top_3.png">
            </span>
            <span>100% Free to use</span>
          </div>
          <div class="infoItem">
            <span class="imgIcon">
              <img src="@/assets/homePage/top_4.png">
            </span>
            <span>1000+ Products Available</span>
          </div>
          <div class="filterBg">
            <div class="btnWrap">
              <a class="designBtn" @click="$emit('toDesign')">Design now</a>
              <!-- <a @click="visible = true">About us ></a> -->
              <a class="btn" @click="visible = true">
                <img src="@/assets/homePage/video_bt.png">
              </a>
            </div>
            <div class="millionBlock">
              <div>
                <img src="@/assets/homePage/fj.png">
              </div>
              <div class="textWrap">
                Over
                <span>1.5 million</span> items shipped every month！
              </div>
            </div>
            <div class="activityBlock">
              <div class="activityFlex">
                <div class="activityItem">
                  <a href="/products/tag/usa" target="_blank">
                    <img src="@/assets/homePage/activity_20.png">
                  </a>
                </div>
                <div class="activityItem">
                  <a href="/activity/metalSignCustom" target="_blank">
                    <img src="@/assets/homePage/activity_2.png">
                  </a>
                </div>
                <div class="activityItem">
                  <a href="/activity/easterGiftZone" target="_blank">
                    <img src="@/assets/homePage/activity_13.png">
                  </a>
                </div>
                <div class="activityItem">
                  <a href="/activity/stPatrickIsDay" target="_blank">
                    <img src="@/assets/homePage/activity_12.png">
                  </a>
                </div>
                <!-- <div class="activityItem">
                  <a href="/holiday" target="_blank">
                    <img src="@/assets/homePage/activity_4.png" />
                  </a>
                </div>-->
              </div>
            </div>
          </div>
        </div>

        <div class="how_it_works">
          <div class="mainWrap">
            <h2 class="comH2">How it works</h2>
            <div class="howWrap">
              <div class="howItem lt sell">
                <img src="@/assets/homePage/how_sell.png" alt="dropshipping platform">
                <div class="howTip">You can focus on selling while we take care of the rest</div>
              </div>
              <div class="howItem rt car">
                <img src="@/assets/homePage/how_car.png" alt="print to packaging and shipping">
                <div class="howTip">
                  We will handle all aspects of production, from printing to packaging and shipping, ensuring that your
                  products reach your customers in top condition and on time.
                </div>
              </div>
              <div class="howItem rt book">
                <img src="@/assets/homePage/how_book.png" alt="print on demand services">
                <div class="howTip">
                  Let us help you take your business to the next level. Discover how Printdoor's print on demand service
                  can benefit you today!
                </div>
              </div>
            </div>
            <div class="howBtn">
              <a href="/how-it-work">Learn more></a>
            </div>
          </div>
        </div>
      </div>
      <PcScrollProduct></PcScrollProduct>
    </div>
    <div class="mbHead">
      <div class="infoWrap">
        <h1>Welcome to PrintDoors</h1>
        <h5>
          Your One-Stop Print-on-Demand and
          <br>Dropshipping Platform!
        </h5>
        <div class="infoFlex">
          <div class="infoItem">
            <span class="imgIcon">
              <img src="@/assets/homePage/top_1.png">
            </span>
            <span>No Minimum Order</span>
          </div>

          <div class="infoItem">
            <span class="imgIcon">
              <img src="@/assets/homePage/top_3.png">
            </span>
            <span>100% Free to use</span>
          </div>
          <div class="infoItem">
            <span class="imgIcon">
              <img src="@/assets/homePage/top_2.png">
            </span>
            <span>One-on-One Services</span>
          </div>
          <div class="infoItem">
            <span class="imgIcon">
              <img src="@/assets/homePage/top_4.png">
            </span>
            <span>1000+ Products Available</span>
          </div>
        </div>
        <div class="btnBox">
          <div class="btn" @click="$emit('toDesignMobile')">Design Now</div>
          <!-- <div class="ltTitle" @click="mbVisible = true">
            <div>
              <img src="@/assets/homePage/top_5.png" />
            </div>
            <div class="tit">About</div>
            <div class="tit">Us</div>
          </div>-->
          <div class="ltTitle" @click="mbVisible = true">
            <img src="@/assets/homePage/mb_video_bt.png">
          </div>
        </div>
      </div>
      <MbScrollProduct></MbScrollProduct>
      <div class="millionBlock">
        <div>
          <img src="@/assets/homePage/fj.png">
        </div>
        <div class="textWrap">
          Over
          <span>1.5 million</span> items shipped every month！
        </div>
      </div>
      <div class="activityBlock">
        <div class="activityFlex">
          <div class="activityItem">
            <a href="/products/tag/usa" target="_blank">
              <img src="@/assets/homePage/activity_20.png">
            </a>
          </div>
          <div class="activityItem">
            <a href="/activity/metalSignCustom">
              <img src="@/assets/homePage/activity_2.png">
            </a>
          </div>
          <div class="activityItem">
            <a href="/activity/easterGiftZone">
              <img src="@/assets/homePage/activity_13.png">
            </a>
          </div>
          <div class="activityItem">
            <a href="/activity/stPatrickIsDay" target="_blank">
              <img src="@/assets/homePage/activity_12.png">
            </a>
          </div>
          <!-- <div class="activityItem">
            <a href="/holiday" target="_blank">
              <img src="@/assets/homePage/activity_4.png" />
            </a>
          </div>-->
        </div>
      </div>
      <div class="how_it_works">
        <div class="mainWrap">
          <h2 class="comH2">How it works</h2>
          <div class="howWrap">
            <div class="howItem lt sell">
              <img src="@/assets/homePage/how_sell.png" alt="sell">
              <div class="howTip">You can focus on selling while we take care of the rest</div>
            </div>
            <div class="howItem rt car">
              <img src="@/assets/homePage/how_car.png" alt="car">
              <div class="howTip">
                We will handle all aspects of production, from printing to packaging and shipping, ensuring that your
                products reach your customers in top condition and on time.
              </div>
            </div>
            <div class="howItem rt book">
              <img src="@/assets/homePage/how_book.png" alt="book">
              <div class="howTip">
                Let us help you take your business to the next level. Discover how Printdoor's print on demand service
                can benefit you today!
              </div>
            </div>
          </div>
          <div class="howBtn">
            <a href="/how-it-work">Learn more></a>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      width="1400px"
      class="aboutModal"
      :visible="visible"
      :footer="null"
      @cancel="visible = false"
    >
      <div class="aboutWrap">
        <a class="close" @click="visible = false">
          <img src="@/assets/homePage/modalClose.png">
        </a>
        <div class="infoBox">
          <div class="imgBox">
            <h1>
              What is
              <span>PrintDoors</span>
            </h1>
            <!-- <video ref="videoPlay" controls>
              <source src="https://youtu.be/kTIKI5B1oSk" type="video/mp4" />
            </video>-->
            <iframe
              style="width: 700px; height: 394px;"
              src="https://www.youtube.com/embed/2YQDdXA-phE?si=NsrMzAqReIPRAUvA"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
          <div class="textWrap">
            <div class="infoText">
              PrintDoors is a leading direct sales platform that specializes in print-on-demand production. We offer a
              range of high-quality products, including clothing, home decor, and accessories, that can be easily
              customized and sold with our user-friendly interface. With over 800 products available and more than 9
              technologies to choose from, you'll have everything you need to get started.
            </div>
            <div class="infoText">
              Our platform is 100% free to use and has no minimum order requirements, so you can start your business
              with ease. Whether you're an individual entrepreneur or a business owner, PrintDoors has everything you
              need to turn your ideas into a successful online store. At PrintDoors, we're committed to providing
              excellent customer service and support, as well as powerful collaboration tools to help you grow your
              business. Join us today and discover the endless possibilities that await you with PrintDoors - Your
              partner in success!
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      width="1400px"
      class="mbAboutModal aboutModal"
      :visible="mbVisible"
      :footer="null"
      @cancel="mbVisible = false"
    >
      <div class="mbAboutWrap">
        <div class="imgBox">
          <iframe
            style="width: 100%;"
            src="https://www.youtube.com/embed/2YQDdXA-phE?si=NsrMzAqReIPRAUvA"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div class="mbInfoBox">
          <div class="textWrap">
            <div class="infoText">
              <span>PrintDoors</span> is a leading direct sales platform that specializes in print-on-demand production.
              We offer a range of high-quality products, including clothing, home decor, and accessories, that can be
              easily customized and sold with our user-friendly interface. With over 800 products available and more
              than 9 technologies to choose from, you'll have everything you need to get started.
            </div>
            <div class="infoText">
              Our platform is 100% free to use and has no minimum order requirements, so you can start your business
              with ease. Whether you're an individual entrepreneur or a business owner, PrintDoors has everything you
              need to turn your ideas into a successful online store. At PrintDoors, we're committed to providing
              excellent customer service and support, as well as powerful collaboration tools to help you grow your
              business. Join us today and discover the endless possibilities that await you with PrintDoors - Your
              partner in success!
            </div>
          </div>
        </div>
        <span class="close" @click="mbVisible = false">
          <!-- <span>×</span> -->
        </span>
      </div>
    </a-modal>
  </div>
</template>

<script>
import PcScrollProduct from './pcScrollProduct'
import MbScrollProduct from './mbScrollProduct'
export default {
  name: 'HeadBlock',
  data() {
    return {
      visible: false,
      mbVisible: false
    }
  },
  props: [],
  computed: {},
  components: {
    PcScrollProduct,
    MbScrollProduct
  },
  watch: {},
  methods: {
    palyFn() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.videoPlay.play()
      })
    },
    openProducts(id) {
      window.open(`/products/${id}`, '_blank')
    }
  },
  mounted() {},
  destroyed() {}
}
</script>

<style lang="less" scoped>
.headBlock {
  .pcHead {
    position: relative;
    width: 1400px;
    margin: 0 auto;
    .infoLt {
      position: relative;
      width: 1456px;
      padding-top: 88px;
      padding-bottom: 30px;
      pointer-events: none;
      background: url('../../../assets/homePage/top_white_bg.png') left top no-repeat;
      z-index: 2;
      h1 {
        margin-bottom: 60px;
        font-size: 60px;
        font-weight: bold;
        color: #333333;
        line-height: 1;
      }
      h5 {
        margin-bottom: 40px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-size: 40px;
        font-weight: 400;
        color: #333333;
        line-height: 54px;
        span {
          // text-shadow: 0 0 5px rgba(255, 255, 255, 1), 0 0 10px rgba(255, 255, 255, 0.8), 0 0 15px rgba(0, 0, 0, 0.8),
          //   0 0 20px rgba(0, 0, 0, 1);
        }
      }
      .infoWrap {
        .infoItem {
          display: flex;
          margin-bottom: 10px;
          align-items: center;
          font-size: 24px;
          font-weight: 400;
          color: #333333;
          .imgIcon {
            padding-right: 6px;
          }
        }
        .btnWrap {
          display: flex;
          align-items: center;
          padding-top: 40px;

          a {
            font-size: 16px;
            font-weight: bold;
            color: #f48900;
            line-height: 1;
            pointer-events: initial;
          }
          .designBtn {
            width: 338px;
            height: 77px;
            margin-right: 40px;
            background: linear-gradient(180deg, #ffb300 0%, #f48900 100%);
            box-shadow: 0px 12px 26px 1px #f9c684;
            border-radius: 8px;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #ffffff;
            line-height: 77px;
          }
          .btn {
            overflow: hidden;
            box-shadow: 0px 12px 26px 1px rgba(249, 198, 132, 0.5);
            border-radius: 8px;
            border: 2px solid #f48900;
            img {
              height: 75px;
            }
          }
        }
        .filterBg {
          // background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 30%);
          background: url('../../../assets/homePage/filterBg.png') center top no-repeat;
        }
        .millionBlock {
          display: flex;
          width: 1260px;
          height: 86px;
          margin: 100px auto 0 auto;
          background: #ffffff;
          box-shadow: 0px 11px 11px 1px rgba(255, 179, 72, 0.31);
          border-radius: 16px 16px 16px 16px;
          opacity: 1;
          border: 2px solid #f48900;
          align-items: center;
          justify-content: center;
          .textWrap {
            font-size: 20px;
            font-weight: bold;
            color: #000000;
            span {
              color: #ffb348;
            }
          }
        }
      }
    }
    // .rightWrap {
    //   overflow: hidden;
    //   position: absolute;
    //   top: 0;
    //   right: 0;
    //   bottom: 0;
    //   width: 928px;
    //   z-index: 0;
    //   .rtProductBox {
    //     display: flex;
    //     justify-content: space-between;
    //     animation-play-state: running;
    //     -webkit-animation-play-state: running;
    //     -webkit-animation: home-scroll-grid-infinite 40s linear 0s infinite;
    //     animation: home-scroll-grid-infinite 40s linear 0s infinite;
    //     &:hover {
    //       animation-play-state: paused;
    //       -webkit-animation-play-state: paused;
    //     }
    //     .flexItem {
    //       .bnRtImg {
    //         margin-top: 20px;
    //         width: 220px;
    //         height: 264px;
    //         border-radius: 4px;
    //         box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
    //         transition: transform 0.3s;
    //         cursor: pointer;
    //         &:hover {
    //           transform: scale(1.08);
    //           // box-shadow: 0 5px 20px 0 rgba(0 0 0, 0.1);
    //         }
    //       }
    //       &:nth-child(1) {
    //         margin-top: -50px;
    //       }
    //       &:nth-child(2) {
    //         margin-top: -130px;
    //       }
    //       &:nth-child(4) {
    //         margin-top: -100px;
    //       }
    //     }
    //   }
    // }
  }
  .mbHead {
    display: none;
  }
}
.aboutWrap {
  position: relative;
  background: url('../../../assets/homePage/modalBg.png') center top no-repeat;
  .close {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .infoBox {
    overflow: hidden;
    padding: 100px 32px 32px 32px;
    .imgBox {
      float: left;
      width: 700px;
      h1 {
        margin: 0 0 70px 0;
        font-size: 68px;
        font-weight: bold;
        color: #333;
        line-height: 88px;
        span {
          color: #f48900;
        }
      }
      img {
        width: 100%;
      }
    }
    .textWrap {
      overflow: hidden;
      padding-left: 32px;
      .infoText {
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        line-height: 38px;
        text-indent: 2em;
      }
    }
  }
}
.mbAboutWrap {
  position: relative;
  padding: 18px 16px;
  .mbInfoBox {
    padding-top: 10px;
    .infoText {
      margin-top: 10px;
      font-size: 10px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 18px;
      text-indent: 2em;
    }
  }
  .close {
    position: absolute;
    left: 50%;
    bottom: -58px;
    margin-left: -21px;
    font-size: 0;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    transform: rotate(45deg);
    &::before {
      position: absolute;
      content: '';
      top: 50%;
      left: 8px;
      right: 8px;
      height: 4px;
      margin-top: -2px;
      border-radius: 2px;
      background: #fff;
      z-index: 1;
    }
    &::after {
      position: absolute;
      content: '';
      top: 8px;
      bottom: 8px;
      left: 50%;
      margin-left: -2px;
      width: 4px;
      border-radius: 2px;
      background: #fff;
      z-index: 1;
    }
    // span {
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   right: 0;
    //   font-size: 42px;
    //   line-height: 1;
    //   text-align: center;
    // }
  }
}

@media screen and (max-width: 960px) {
  .headBlock {
    .pcHead {
      display: none;
    }
    .mbHead {
      display: block;
      position: relative;
      .infoWrap {
        position: relative;
        padding: 250px 16px 30px 16px;
        background: url('../../../assets/homePage/mb_top_white_bg.png') center top no-repeat;
        pointer-events: none;
        z-index: 2;
        h1 {
          font-size: 32px;
          font-weight: bold;
          color: #ffb100;
          line-height: 1;
          text-align: right;
        }
        h5 {
          margin: 0;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          text-align: right;
        }
        .infoFlex {
          display: flex;
          margin-top: 16px;
          justify-content: space-between;
          flex-flow: wrap;
          .infoItem {
            display: flex;
            margin-top: 8px;
            width: 49%;
            height: 42px;
            padding: 0 10px;
            font-size: 10px;
            font-weight: 400;
            color: #333333;
            align-items: center;
            background: #fff4e7;
            .imgIcon {
              padding: 0 8px 0 0;
              img {
                width: 32px;
              }
            }
          }
        }
        .btnBox {
          // display: flex;
          // justify-content: space-between;
          // align-items: center;
          margin-top: 16px;
          pointer-events: initial;
          .ltTitle {
            // width: 64px;
            // height: 50px;
            // margin-right: 8px;
            // background: #fff4e7;
            // border-radius: 4px;
            // text-align: center;
            // img {
            //   width: 20px;
            // }
            // .tit {
            //   font-size: 10px;
            //   font-weight: bold;
            //   color: #f48900;
            //   line-height: 1;
            // }
            overflow: hidden;
            width: 100%;
            margin-top: 16px;
            box-shadow: 0px 12px 26px 1px rgba(249, 198, 132, 0.5);
            border-radius: 4px;
            border: 1px solid #f48900;
            img {
              width: 100%;
            }
          }
          .btn {
            flex: 1;
            height: 50px;
            background: linear-gradient(180deg, #ffb300 0%, #f48900 100%);
            box-shadow: 0px 4px 8px 1px #ffbc65;
            border-radius: 4px 4px 4px 4px;
            font-size: 16px;
            font-weight: bold;
            line-height: 50px;
            color: #ffffff;
            text-align: center;
          }
        }
      }
      .millionBlock {
        display: flex;
        height: 32px;
        margin: 0 16px 20px 16px;
        background: #ffffff;
        box-shadow: 0px 5px 5px 1px rgba(255, 179, 72, 0.31);
        border-radius: 16px 16px 16px 16px;
        opacity: 1;
        border: 2px solid #f48900;
        align-items: center;
        justify-content: center;
        .textWrap {
          font-size: 14px;
          font-weight: bold;
          color: #000000;
          span {
            color: #ffb348;
          }
        }
      }
    }
  }
  .mbAboutModal {
    max-width: calc(100vw - 32px);
    margin: 16px auto;
  }
}
</style>
